
import { PropType } from "vue";
import { Options, prop, Vue } from "vue-class-component";
import ToggleV2 from "@/app/ui/components/toggle-v2/index.vue";
import DayScheduleRow from "./DayScheduleRow.vue";
import {
  REGULAR_DAY_KEYS,
  RegularDayKey,
  RegularDaySchedule,
  RegularTimeSlot
} from "./schedule-types";

class Props {
  enabled = prop<boolean>({ default: false, type: Boolean });
  days = prop<RegularDaySchedule[]>({
    default: () => [],
    type: Array as PropType<RegularDaySchedule[]>
  });
  loading = prop<boolean>({ default: false, type: Boolean });
  slotStartHour = prop<number>({ default: 8, type: Number });
  slotEndHour = prop<number>({ default: 23, type: Number });
  slotIntervalMinutes = prop<number>({ default: 60, type: Number });
}

@Options({
  components: {
    DayScheduleRow,
    ToggleV2
  },
  emits: ["update:enabled", "update:days"]
})
export default class RegularScheduleSection extends Vue.with(Props) {
  openDay: RegularDayKey | "" = "";
  isActiveTooltip = false;

  get enabledValue(): boolean {
    return this.enabled;
  }

  set enabledValue(value: boolean) {
    this.$emit("update:enabled", value);
    this.openDay = "";
  }

  get normalizedDays(): RegularDaySchedule[] {
    return REGULAR_DAY_KEYS.map((day) => {
      return (
        this.days.find((schedule) => schedule.day === day) || {
          day,
          checked: true,
          slots: []
        }
      );
    });
  }

  toggleDay(day: RegularDayKey): void {
    this.openDay = this.openDay === day ? "" : day;
  }

  updateChecked(day: RegularDayKey, checked: boolean): void {
    this.updateDay(day, { checked });
  }

  updateSlots(day: RegularDayKey, slots: RegularTimeSlot[]): void {
    const sortedSlots = [...slots].sort((a, b) =>
      a.start.localeCompare(b.start)
    );
    this.updateDay(day, { slots: sortedSlots });
  }

  private updateDay(
    day: RegularDayKey,
    fields: Partial<RegularDaySchedule>
  ): void {
    this.$emit(
      "update:days",
      this.normalizedDays.map((schedule) =>
        schedule.day === day ? { ...schedule, ...fields } : schedule
      )
    );
  }
}
